import { Component, EventEmitter, OnInit } from '@angular/core';
import { MembershipService } from '../../services/membership.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { MembershipPlanList } from '../../models/membership-plan-list';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { MembershipPlansListQueryFilter } from './membership-plans-list-query-filter';
import { Sort } from '@angular/material/sort';
import { MembershipPlanCreateModalComponent } from '../../modals/membership/membership-plan-create-modal/membership-plan-create-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { MembershipPlanEditModalComponent } from '../../modals/membership/membership-plan-edit-modal/membership-plan-edit-modal.component';
import { AlertModalComponent } from 'src/app/shared/modals/alert-modal/alert-modal.component';

@Component({
  selector: 'membership-plans-list',
  templateUrl: './membership-plans-list.component.html',
  styleUrl: './membership-plans-list.component.scss',
  standalone: false,
})
export class MembershipPlansListComponent extends BaseComponent implements OnInit {
  membershipPlans: MembershipPlanList[] = [];
  isLoading = false;
  filter: MembershipPlansListQueryFilter = new MembershipPlansListQueryFilter();
  public updateFilterEvent = new EventEmitter<any>();

  constructor(sessionService: SessionService, private membershipService: MembershipService, stringHelpers: StringHelpers, private dialog: MatDialog) {
    super(sessionService, stringHelpers);
    this.filter.organizationId = this.sessionService.getUser().organizationId;
    this.displayedColumns = ['name', 'description', 'price', 'billingInterval', 'billingIntervalCount', 'maxBookingsPerMonth', 'discountPercent', 'isActive', 'actions'];
  }

  ngOnInit(): void {
    this.getMembershipPlans();
  }

  getMembershipPlans() {
    this.isLoading = true;
    this.membershipService.getAllPlansByOrganization(this.filter).subscribe({
      next: (result: any) => {
        this.membershipPlans = result.results || result;
        this.filter.totalCount = result.totalCount;
        this.updateFilterEvent.emit(result.results);
        this.isLoading = false;
      },
      error: (error: any) => {
        this.isLoading = false;
        console.error(error);
      }
    });
  }

  sortData(sort: Sort) {
    this.filter.sortDirection = sort.direction;
    this.filter.sortColumn = sort.active;
    this.getMembershipPlans();
  }

  resetFilter() {
    this.filter.page = 1;
    this.filter.text = '';
    this.filter.pageSize = 15;
  }

  addMembershipPlan() {
    const dialogRef = this.dialog.open(MembershipPlanCreateModalComponent);

    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getMembershipPlans();
      }
    });
  }

  editMembershipPlan(plan: MembershipPlanList) {
    const dialogRef = this.dialog.open(MembershipPlanEditModalComponent, {
      data: plan
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result === "save"){
        this.getMembershipPlans();
      }
    });
  }

  deleteMembershipPlan(plan: MembershipPlanList) {
    const dialogRef = this.dialog.open(AlertModalComponent);
    dialogRef.componentInstance.title = 'Delete Membership Plan';
    dialogRef.componentInstance.body = `<h3 class="text-danger mat-h3">WARNING! THIS ACTION CANNOT BE UNDONE</h3> <br /> Are you sure you want to delete Membership Plan <strong>${plan.name}</strong>? <br />Your customers will no longer be able to purchase this plan and use their discount code associated with this plan.</h2>`;
    dialogRef.componentInstance.submitText = 'Yes';
    dialogRef.componentInstance.otherText = 'No';
    dialogRef.componentInstance.isOtherTextDisabled = false;
    dialogRef.afterClosed().subscribe((response) => {
      if(response === 'Yes'){
        this.isLoading = true;
        let data = {id: plan.id, accountId: this.sessionService.getUser().stripeAccountId, stripeProductId: plan.stripeProductId, lastEditedBy: this.getUserIdFromSession()};
        this.membershipService.deletePlan(data).subscribe(() => {
          this.getMembershipPlans();
          this.isLoading = false;
        }, err =>{
          this.isLoading = false;
          //throw error
        });
      }
    });
  }
}
